"use strict";

import etc from './etc';
import ext from './ext';
import gui from './gui';

export default {
  etc,
  ext,
  gui
};
